<template>
  <div>
    <!-- 校验手机号 -->
    <div v-if="showVerify" class="container">
      <cube-form :model="formData" :schema="schema"></cube-form>
      <span @click="toVerify()">检测</span>
    </div>
    <!-- 用户信息展示 -->
    <div v-if="showUserInfo" class="user_info">
      <div class="user_photo">
        <div class="user_photo_graph">
          <img :src="userData.headimgurl" alt="">
        </div>
        <div class="user_name">
          <span>{{userData.nickname}}</span>
        </div>
      </div>
      <div class="user_other">
        <div class="user_name user_info_item">
          <span class="left">昵称</span>
          <span class="right">{{userData.nickname}}</span>
        </div>
        <div class="user_sex user_info_item">
          <span class="left">性别</span>
          <span class="right">{{userData.sex == 1 ? '男' : userData.sex == 0 ? '女' : ''}}</span>
        </div>

        <div class="user_phone user_info_item">
          <span class="left">手机号</span>
          <span class="right">{{userData.phone}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axios } from "../../util/request";
export default {
  data() {
    return {
      // 用户信息
      userData: '',
      showVerify: true,
      showUserInfo: false,
      userInfo: {
        userId: '',
        code: this.$route.query.code,
      },
      // params: this.$route.query,
      formData: {
        mobile: ''
      },
      schema: {
        fields: [
          {
            type: 'input',
            modelKey: 'mobile',
            label: '手机号',
            props: {
              placeholder:'请输入申请办理的手机号',
              type: 'number',
            },
            rules: {
              //校验规则
              required: true,
              min:11,
              max:11
            },
            trigger: 'blur',
            messages: {
              required:'手机号不能为空',
              min:'手机号位数有误',
              max:'手机号位数有误'
            } 
          },
        ]
      },
      state: false,
    };
  },
  methods: {
    createDialog(title,content){
        this.$createDialog({
        type: 'alert',
        title: title,
        content: content,
        icon: 'cubeic-alert'
      }).show()
    },
    toVerify() {
      if(this.state) {
        return false;
      }
      this.state = true;
      if (!(/^1[3456789]\d{9}$/.test(this.formData.mobile.replace(/\s/g,"")))) {
        this.createDialog('用户提示','手机号格式不正确，请核对手机号');
      } else {
        // console.log(this.formData.mobile.replace(/\s/g,""));
        axios.post('/WeChat/CheckPhone',{phoneNumber:this.formData.mobile.replace(/\s/g,"")}).then(data => {
          console.log(data);
          if(data.state == 1) {
            this.userInfo.userId = data.userId;
            // this.userInfo.code = sessionStorage.getItem('CODE');
            console.log('有用户办理的信息');
            // axios.get('/WeChat/Auth').then(data => {
            //   console.log(data);
            //   window.location.href = data;
            // }).catch(err => {
            if(this.userInfo.code) {
              axios.post('/WeChat/WeChatUserInfo',this.userInfo).then(data => {
                console.log(data);
                if(data.state == 1) {
                  this.showVerify = false;
                  this.showUserInfo = true;
                  this.userData = data;
                } else {
                  this.createDialog('用户提示','授权失败');
                }
              })
            }
            // })
          } else {
            // 没有用户信息是跳转到home页面，还是给出提示
            this.createDialog('用户提示','您未办理申请流程，暂时不能同步信息。');
          }
        }).catch(err => {
          this.createDialog('系统提示','系统异常。');
        })
      }
      this.state = false;
    }
  },
};
</script>

<style  scoped lang="less">
@import '../../assets/styles/varibles.less';
.container {
  width: 100%;
  background-color: #fff;
  padding: 30px 20px 20px 20px;
  box-sizing: border-box;
  .cube-form {
    margin-bottom: 20px;
  }
  span {
    display: inline-block;
    width: 250px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #ffffff;
    color: #f18934;
    font-size: 15px;
    font-weight: 400;
    border-radius: 20px;
    border:1px solid #f18934;
  }
}
.user_info {
  height: calc(100vh);
  width: 100%;
  background-color: #f2f2f2;
  padding: 10px 10px 10px 10px;
  box-sizing: border-box;
  .user_photo {
    height: 120px;
    border-radius: 10px;
    width: 100%;
    background: @titleColor;
    .user_photo_graph {
      float: left;
      height: 80px;
      width: 80px;
      border-radius: 50%;
      background-color: #fff;
      margin-left: 30px;
      margin-top: 20px;
      overflow: hidden;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .user_name {
      float: left;
      height: 120px;
      width: 200px;
      margin-left: 30px;
      line-height: 120px;
      text-align: left;
      font-size: 20px;
      color: #fff;
    }
  }
  .user_other {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    margin-top: 10px;
    padding: 10px 20px 10px 20px;
    box-sizing: border-box;
    .user_info_item {
      height: 50px;
      line-height: 50px;
      width: 100%;
      border-bottom: 1px solid #cacaca;
      text-align: left;
      .left {
        float: left;
        width: 70px;
        margin-right: 30px;
        text-align-last:justify;
        text-align:justify;
        text-justify:distribute-all-lines; 
      }
      .right {
        float: left;
      }
    }
    .user_phone {
      border-bottom: none;
    }
  }
}
</style>
